import { Button } from '@/shared/components/ui/button'
import type { ICall } from '@/shared/api/calls'

export default function MyCalls() {
  const calls: ICall[] = []

  return (
    <div className='fv:flex fv:flex-col fv:items-center fv:flex-1 fv:relative fv:overflow-auto'>
      <Button asChild variant='outline' className='fv:absolute fv:top-2 fv:left-2'>
        <a href='/'>Rails Version</a>
      </Button>
      <div className='fv:flex fv:flex-col fv:items-center fv:h-full fv:w-full'>
        <ul>
          {calls.map((call) => (
            <li key={call.id}>{call.title}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
